import React, { forwardRef } from 'react'
import { FieldTypes } from 'utils/formUtils';
import WallarmMappingForm from './WallarmMappingForm';
import GenericPullCredentialsForm from '../GenericPullCredentialsForm';

function WallarmCredentialForm(props, ref) {
    const fields = [
    {
        name: "uuid",
        label: "UUID",
        required: true
    }, {
        name: "secret",
        label: "Secret key",
        required: true,
        type: FieldTypes.PASSWORD,
    }];

    return (
        <GenericPullCredentialsForm
            {...props}
            ref={ref}
            fields={fields}
            MappingForm={WallarmMappingForm}
        />
    )
}

export default forwardRef(WallarmCredentialForm);